import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-outer-pages-header',
  templateUrl: './outer-pages-header.component.html',
  styleUrls: ['./outer-pages-header.component.css']
})
export class OuterPagesHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    let page= document.location.pathname;
    $("a[href='"+page+"']").addClass("active");
  }

}
